// ==========================================================================================
// YouTube Background Video Player (with Bootstrap Modal Integration)
// ==========================================================================================
//
// INSTRUCTIONS FOR USING THIS YOUTUBE PLAYER:
// ==========================================================================================
//
// 1. HTML STRUCTURE OPTIONS:
//    ------------------------
//
//    OPTION A: MODAL IMPLEMENTATION (Recommended for popup videos)
//    ------------------------------------------------------------
//    <!-- Button to open video in modal -->
//    <button type="button" class="btn btn-primary" data-bs-toggle="modal" 
//            data-bs-target="#videoModal" 
//            data-youtube-id="YOUR_YOUTUBE_VIDEO_ID" 
//            data-player-id="unique-player-id">
//        Open Video
//    </button>
//
//    <!-- Modal Structure -->
//    <div class="modal fade" id="videoModal" tabindex="-1" aria-labelledby="videoModalLabel" aria-hidden="true">
//        <div class="modal-dialog modal-lg">
//            <div class="modal-content">
//                <div class="modal-header">
//                    <h5 class="modal-title" id="videoModalLabel">Video Title</h5>
//                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
//                </div>
//                <div class="modal-body">
//                    <div class="background-video-player" 
//                         data-youtube-id="YOUR_YOUTUBE_VIDEO_ID" 
//                         data-player-id="unique-player-id">
//                        <div id="unique-player-id"></div>
//                        <button class="volume-btn btn btn-sm btn-outline-light position-absolute" 
//                                style="top: 10px; right: 10px; z-index: 1000;">
//                            <i class="fa-solid fa-volume-up"></i>
//                            <i class="fa-solid fa-volume-off" style="display: none;"></i>
//                        </button>
//                    </div>
//                </div>
//            </div>
//        </div>
//    </div>
//
//    OPTION B: DIRECT EMBED (For videos embedded directly on page)
//    ------------------------------------------------------------
//    <!-- Video embedded directly in page content -->
//    <div class="container my-5">
//        <h2>Welcome Video</h2>
//        <div class="background-video-player" 
//             data-youtube-id="YOUR_YOUTUBE_VIDEO_ID" 
//             data-player-id="welcome-video">
//            <div id="welcome-video"></div>
//            <!-- Custom Play/Pause Button (appears on hover) -->
//            <button class="play-pause-btn btn btn-outline-light">
//                <i class="fa-solid fa-play"></i>
//                <i class="fa-solid fa-pause" style="display: none;"></i>
//            </button>
//            <!-- Volume Control Button -->
//            <button class="volume-btn btn btn-sm btn-outline-light">
//                <i class="fa-solid fa-volume-up"></i>
//                <i class="fa-solid fa-volume-off" style="display: none;"></i>
//            </button>
//        </div>
//    </div>
//
//    OPTION C: BACKGROUND VIDEO (For hero sections)
//    ----------------------------------------------
//    <!-- Background video in hero section -->
//    <div class="hero-section position-relative">
//        <div class="background-video-player" 
//             data-youtube-id="YOUR_YOUTUBE_VIDEO_ID" 
//             data-player-id="hero-video">
//            <div id="hero-video"></div>
//            <button class="volume-btn btn btn-sm btn-outline-light position-absolute" 
//                    style="top: 10px; right: 10px; z-index: 1000;">
//                <i class="fa-solid fa-volume-up"></i>
//                <i class="fa-solid fa-volume-off" style="display: none;"></i>
//            </button>
//        </div>
//        <div class="hero-content position-absolute w-100 h-100 d-flex align-items-center justify-content-center">
//            <div class="text-center text-white">
//                <h1>Welcome to ATW Airport</h1>
//                <p>Your gateway to adventure</p>
//            </div>
//        </div>
//    </div>
//
// 2. REQUIRED ATTRIBUTES:
//    --------------------
//    - data-youtube-id: The YouTube video ID (e.g., "dQw4w9WgXcQ" from https://www.youtube.com/watch?v=dQw4w9WgXcQ)
//    - data-player-id: A unique identifier for each player instance
//    - data-bs-target: The modal ID to open (for modal implementation)
//
// 3. FEATURES:
//    ----------
//    - Automatic YouTube API loading
//    - Modal integration with Bootstrap
//    - Volume control button
//    - Auto-play when modal opens
//    - Auto-pause when modal closes
//    - Multiple players on same page support
//    - Error handling and retry logic
//
// 4. CSS REQUIREMENTS:
//    -----------------
//    /* Basic video player styling (required for all options) */
//    .background-video-player {
//        position: relative;
//        width: 100%;
//        height: 0;
//        padding-bottom: 56.25%; /* 16:9 aspect ratio */
//    }
//    
//    .background-video-player iframe {
//        position: absolute;
//        top: 0;
//        left: 0;
//        width: 100%;
//        height: 100%;
//    }
//
//    /* For background video (Option C) */
//    .hero-section .background-video-player {
//        position: absolute;
//        top: 0;
//        left: 0;
//        width: 100%;
//        height: 100%;
//        padding-bottom: 0;
//        z-index: 1;
//    }
//
//    .hero-section .background-video-player iframe {
//        position: absolute;
//        top: 50%;
//        left: 50%;
//        transform: translate(-50%, -50%);
//        min-width: 100%;
//        min-height: 100%;
//        width: auto;
//        height: auto;
//    }
//
//    .hero-content {
//        z-index: 2;
//        position: relative;
//    }
//
// 5. EXAMPLE USAGE:
//    --------------
//    <!-- Button to open video modal -->
//    <button type="button" class="btn btn-primary" data-bs-toggle="modal" 
//            data-bs-target="#airportVideoModal" 
//            data-youtube-id="abc123xyz" 
//            data-player-id="airport-video-1">
//        Watch Airport Video
//    </button>
//
//    <!-- Modal with video player -->
//    <div class="modal fade" id="airportVideoModal" tabindex="-1">
//        <div class="modal-dialog modal-lg">
//            <div class="modal-content">
//                <div class="modal-header">
//                    <h5 class="modal-title">Welcome to ATW Airport</h5>
//                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
//                </div>
//                <div class="modal-body">
//                    <div class="background-video-player" 
//                         data-youtube-id="abc123xyz" 
//                         data-player-id="airport-video-1">
//                        <div id="airport-video-1"></div>
//                        <button class="volume-btn btn btn-sm btn-outline-light position-absolute" 
//                                style="top: 10px; right: 10px; z-index: 1000;">
//                            <i class="fa-solid fa-volume-up"></i>
//                            <i class="fa-solid fa-volume-off" style="display: none;"></i>
//                        </button>
//                    </div>
//                </div>
//            </div>
//        </div>
//    </div>
//
// 6. TROUBLESHOOTING:
//    ----------------
//    - Check browser console for error messages
//    - Ensure YouTube video ID is correct and video is public
//    - Verify all required data attributes are present
//    - Make sure Bootstrap modal JavaScript is loaded
//    - Check that Font Awesome icons are available for volume button
//
// ==========================================================================================

window.youtubePlayers = {};
let ytApiLoaded = false;

// Player ready event handler
window.onPlayerReady = function(event) {
    const playerIframe = event.target.getIframe();
    
    // Store the ready state for this player
    if (playerIframe) {
        const playerId = playerIframe.id;
        if (window.youtubePlayers[playerId]) {
            window.youtubePlayers[playerId].isReady = true;
        }
    }
};

// Player state change event handler
window.onPlayerStateChange = function(event) {
    const playerIframe = event.target.getIframe();
    const playerWrapper = playerIframe.closest('.background-video-player');
    const volumeBtn = playerWrapper.querySelector('.volume-btn');
    const playPauseBtn = playerWrapper.querySelector('.play-pause-btn');
    
    // Update volume button state
    if (volumeBtn) {
        const volumeOnIcon = volumeBtn.querySelector('.fa-volume-up');
        const volumeOffIcon = volumeBtn.querySelector('.fa-volume-off');

        if (event.data === YT.PlayerState.PLAYING) {
            // Video is playing - update volume button state
            if (event.target.isMuted()) {
                volumeOnIcon.style.display = 'none';
                volumeOffIcon.style.display = 'inline-block';
            } else {
                volumeOnIcon.style.display = 'inline-block';
                volumeOffIcon.style.display = 'none';
            }
        }
    }
    
    // Update play/pause button state
    if (playPauseBtn) {
        const playIcon = playPauseBtn.querySelector('.fa-play');
        const pauseIcon = playPauseBtn.querySelector('.fa-pause');
        
        if (event.data === YT.PlayerState.PLAYING) {
            playIcon.style.display = 'none';
            pauseIcon.style.display = 'inline-block';
        } else if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
            playIcon.style.display = 'inline-block';
            pauseIcon.style.display = 'none';
        }
    }
}

// YouTube API ready handler
window.onYouTubeIframeAPIReady = function() {
    initializePlayers();
}

function initializePlayers() {
    const players = document.querySelectorAll('.background-video-player');
    
    players.forEach(playerWrapper => {
        const youtubeId = playerWrapper.dataset.youtubeId;
        const playerId = playerWrapper.dataset.playerId;
        
        if (youtubeId && playerId && !window.youtubePlayers[playerId]) {
            try {
                window.youtubePlayers[playerId] = new YT.Player(playerId, {
                    height: '360',
                    width: '640',
                    videoId: youtubeId,
                    playerVars: {
                        autoplay: 0, 
                        controls: 0, // Hide YouTube controls
                        showinfo: 0, 
                        modestbranding: 1,
                        loop: 0, 
                        fs: 0, // Disable fullscreen button
                        cc_load_policy: 0,
                        iv_load_policy: 3, 
                        autohide: 1, // Hide controls automatically
                        playsinline: 1,
                        rel: 0, // Don't show related videos
                        origin: window.location.origin,
                        enablejsapi: 1,
                        disablekb: 0, // Allow keyboard controls
                        color: 'white', // Progress bar color
                        hl: 'en' // Language
                    },
                    events: { 
                        'onReady': window.onPlayerReady,
                        'onStateChange': window.onPlayerStateChange
                    }
                });
            } catch (error) {
                console.error('Error creating YouTube player:', error);
            }
        }
    });
}

function loadYouTubeAPI() {
    if (ytApiLoaded) {
        // If API is loaded but new players were added, re-run the initialization.
        if (window.YT && typeof window.YT.Player === 'function') {
            initializePlayers();
        }
        return;
    }
    ytApiLoaded = true;
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

function attemptToPlayVideo(playerId, maxAttempts = 10) {
    let attempts = 0;
    
    function tryPlay() {
        attempts++;
        
        const player = window.youtubePlayers[playerId];
        
        if (player && typeof player.playVideo === 'function') {
            try {
                // Check player state first
                const currentState = player.getPlayerState();
                
                // If player is already playing, don't try to play again
                if (currentState === YT.PlayerState.PLAYING) {
                    return true;
                }
                
                // First, try to unmute the player (browsers often block autoplay with sound)
                if (player.isMuted && player.isMuted()) {
                    player.unMute();
                }
                
                player.playVideo();
                
                // Check if it actually started playing
                setTimeout(() => {
                    const state = player.getPlayerState();
                    if (state === YT.PlayerState.PLAYING) {
                        // Video is now playing
                    } else if (state === YT.PlayerState.BUFFERING) {
                        // Video is buffering
                    }
                }, 1000);
                
                return true;
            } catch (error) {
                console.error('Error playing video:', error);
            }
        }
        
        if (attempts < maxAttempts) {
            setTimeout(tryPlay, 1000);
        } else {
            console.error('Failed to play video after', maxAttempts, 'attempts');
        }
        
        return false;
    }
    
    return tryPlay();
}

// Bootstrap Modal Integration and Direct Embed Support
document.addEventListener('DOMContentLoaded', function() {
    // Handle modal show events for all video modals
    document.addEventListener('show.bs.modal', function(event) {
        const modal = event.target;
        const button = event.relatedTarget;
        
        // Check if this is a video modal
        if (modal.querySelector('.background-video-player')) {
            const youtubeId = button.getAttribute('data-youtube-id');
            const playerId = button.getAttribute('data-player-id');
            
            // Load YouTube API if not already loaded
            loadYouTubeAPI();
            
            // Wait for modal to fully open, then attempt to play
            setTimeout(() => {
                attemptToPlayVideo(playerId);
            }, 2000); // Increased delay to ensure modal is fully open
        }
    });
    
    // Handle modal hide events for all video modals
    document.addEventListener('hide.bs.modal', function(event) {
        const modal = event.target;
        
        // Check if this is a video modal
        if (modal.querySelector('.background-video-player')) {
            const playerWrappers = modal.querySelectorAll('.background-video-player');
            playerWrappers.forEach(wrapper => {
                const playerId = wrapper.dataset.playerId;
                const player = window.youtubePlayers[playerId];
                if (player && typeof player.pauseVideo === 'function') {
                    player.pauseVideo();
                }
            });
        }
    });
    
    // Check if any video players exist on initial load (for direct embed)
    if (document.querySelector('.background-video-player')) {
        loadYouTubeAPI();
        
        // For direct embed videos, we might want to auto-play them when they come into view
        const videoPlayers = document.querySelectorAll('.background-video-player');
        videoPlayers.forEach(playerWrapper => {
            const playerId = playerWrapper.dataset.playerId;
            
            // Create an intersection observer to auto-play when video comes into view
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // Optionally auto-play when video comes into view
                        // Uncomment the next line if you want auto-play on scroll
                        // attemptToPlayVideo(playerId);
                    }
                });
            }, {
                threshold: 0.5 // Trigger when 50% of video is visible
            });
            
            observer.observe(playerWrapper);
        });
    }
});

// Add event listeners for custom controls
document.addEventListener('click', function(e) {
    // Handle Volume Button
    if (e.target.closest('.volume-btn')) {
        const volumeBtn = e.target.closest('.volume-btn');
        const playerWrapper = volumeBtn.closest('.background-video-player');
        const playerId = playerWrapper.dataset.playerId;
        const player = window.youtubePlayers[playerId];
        
        if (player && typeof player.isMuted === 'function') {
            const volumeOnIcon = volumeBtn.querySelector('.fa-volume-up');
            const volumeOffIcon = volumeBtn.querySelector('.fa-volume-off');

            if (player.isMuted()) {
                player.unMute();
                volumeOnIcon.style.display = 'inline-block';
                volumeOffIcon.style.display = 'none';
            } else {
                player.mute();
                volumeOnIcon.style.display = 'none';
                volumeOffIcon.style.display = 'inline-block';
            }
        }
    }
    
    // Handle Play/Pause Button
    if (e.target.closest('.play-pause-btn')) {
        const playPauseBtn = e.target.closest('.play-pause-btn');
        const playerWrapper = playPauseBtn.closest('.background-video-player');
        const playerId = playerWrapper.dataset.playerId;
        const player = window.youtubePlayers[playerId];
        
        if (player && typeof player.getPlayerState === 'function') {
            const playIcon = playPauseBtn.querySelector('.fa-play');
            const pauseIcon = playPauseBtn.querySelector('.fa-pause');
            const currentState = player.getPlayerState();
            
            if (currentState === YT.PlayerState.PLAYING) {
                player.pauseVideo();
                playIcon.style.display = 'inline-block';
                pauseIcon.style.display = 'none';
            } else {
                player.playVideo();
                playIcon.style.display = 'none';
                pauseIcon.style.display = 'inline-block';
            }
        }
    }
    
    // Handle video area click for play/pause
    if (e.target.closest('.background-video-player') && !e.target.closest('.volume-btn') && !e.target.closest('.play-pause-btn')) {
        const playerWrapper = e.target.closest('.background-video-player');
        const playerId = playerWrapper.dataset.playerId;
        const player = window.youtubePlayers[playerId];
        
        if (player && typeof player.getPlayerState === 'function') {
            const currentState = player.getPlayerState();
            const playPauseBtn = playerWrapper.querySelector('.play-pause-btn');
            
            if (playPauseBtn) {
                const playIcon = playPauseBtn.querySelector('.fa-play');
                const pauseIcon = playPauseBtn.querySelector('.fa-pause');
                
                if (currentState === YT.PlayerState.PLAYING) {
                    player.pauseVideo();
                    playIcon.style.display = 'inline-block';
                    pauseIcon.style.display = 'none';
                } else {
                    player.playVideo();
                    playIcon.style.display = 'none';
                    pauseIcon.style.display = 'inline-block';
                }
            }
        }
    }
});
